export const PRODUCT_COUNT_QUERY_KEY = 'PRODUCT_COUNT';
export const KEYWORD_COUNT_QUERY_KEY = 'KEYWORD_COUNT';
